/* eslint-disable jsx-a11y/no-autofocus */
/* eslint-disable react/jsx-no-useless-fragment */
import PropTypes from 'prop-types';
import { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import box from '../../assets/images/box.png';
import iconButtonClose from '../../assets/images/buttonclose.svg';
import iconLocation from '../../assets/images/location.svg';
import iconSearch from '../../assets/images/search.svg';
import Modal from '../../assets/styles/Modal';
import Text from '../../assets/styles/Text';
import { useAdsByLocation } from '../../hooks/queries/useAds';
import { useCities, useCitiesHighlights } from '../../hooks/queries/useCities';
import { normalizeForSearch } from '../../utils/stringUtils';
import Ad from '../Ad';
import Loader from '../Loader';
import ReactPortal from '../ReactPortal';
import * as styles from './styles';

export default function PopUpSearch({ show, onHideWindow }) {
  const [search, setSearch] = useState('');

  const { data: cities = [], isLoading: isLoadingCities } = useCities({
    enabled: show,
  });

  const { data: citiesHighlights = [], isLoading: isLoadingHighlights } =
    useCitiesHighlights({
      enabled: show,
    });

  const { data: ads = [] } = useAdsByLocation('SEARCH');

  // Filter for cities search
  const filteredCities = useMemo(() => {
    if (!search || search.length === 0) {
      return [];
    }

    const searchNormalized = normalizeForSearch(search);

    // Include term of search
    const filtered = cities.filter((city) =>
      normalizeForSearch(city?.name || '').includes(searchNormalized)
    );

    // Return exact and then by NumModel
    return filtered.sort((a, b) => {
      const aNameNormalized = normalizeForSearch(a?.name || '');
      const bNameNormalized = normalizeForSearch(b?.name || '');

      const aExactMatch = aNameNormalized === searchNormalized;
      const bExactMatch = bNameNormalized === searchNormalized;

      // Priority by exact name
      if (aExactMatch && !bExactMatch) return -1;
      if (!aExactMatch && bExactMatch) return 1;

      // Order by NumModel
      return (b?.numModel || 0) - (a?.numModel || 0);
    });
  }, [search, cities]);

  const isLoading = isLoadingCities || isLoadingHighlights;
  const searchIsEmpty = search.length === 0;

  // Reset close
  function handleClose() {
    setSearch('');
    onHideWindow();
  }

  if (!show) return null;

  return (
    <ReactPortal containerId="popup-search">
      <Modal onClick={handleClose}>
        <styles.Container onClick={(e) => e.stopPropagation()}>
          <styles.ButtonClose onClick={handleClose}>
            <img src={iconButtonClose} alt="Fechar" />
          </styles.ButtonClose>

          <styles.Top>
            <input
              type="text"
              placeholder="Pesquise pela sua cidade"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              autoFocus
            />
            <img src={iconSearch} alt="Buscar" />
          </styles.Top>

          {isLoading ? (
            <Loader isLoading minimal />
          ) : (
            <styles.Body>
              {searchIsEmpty && <Text.Span>Cidades recomendadas</Text.Span>}

              {searchIsEmpty ? (
                <styles.Recommended>
                  {citiesHighlights.map((city) => (
                    <Link
                      to={`/cities/${city.id}`}
                      key={city.id}
                      onClick={handleClose}
                    >
                      <img src={iconLocation} alt="Localização" />
                      <div>
                        <Text.Span $bold>
                          {city.name} - {city.stateAc}
                        </Text.Span>
                        <small>
                          {city.numModel}{' '}
                          {city.numModel === 1 ? 'modelo' : 'modelos'}
                        </small>
                      </div>
                    </Link>
                  ))}
                </styles.Recommended>
              ) : (
                <>
                  {filteredCities.length > 0 ? (
                    filteredCities.slice(0, 7).map((city) => (
                      <Link
                        to={`/cities/${city.id}`}
                        key={city.id}
                        onClick={handleClose}
                      >
                        <img src={iconLocation} alt="Localização" />
                        <Text.P>
                          {city.name} - {city.stateAc} /
                          <span>
                            {' '}
                            {city.numModel}{' '}
                            {city.numModel === 1 ? 'modelo' : 'modelos'}
                          </span>
                        </Text.P>
                      </Link>
                    ))
                  ) : (
                    <styles.Empty>
                      <img src={box} alt="Vazio" />
                      <Text.H4 $bold>Nenhuma cidade encontrada</Text.H4>
                    </styles.Empty>
                  )}
                </>
              )}
            </styles.Body>
          )}

          {searchIsEmpty && ads.length > 0 && (
            <styles.Ads>
              {ads.map((ad) => (
                <Ad key={ad.id} img={ad.url} link={ad.link} />
              ))}
            </styles.Ads>
          )}
        </styles.Container>
      </Modal>
    </ReactPortal>
  );
}

PopUpSearch.propTypes = {
  show: PropTypes.bool.isRequired,
  onHideWindow: PropTypes.func.isRequired,
};
